import { defineMessages } from 'react-intl';

export const messages = defineMessages({
	supportEngineersCardTitle: {
		id: 'fastshift.relationships-card.title.support-engineers',
		defaultMessage: 'Migration Support Engineers',
		description: 'Title for the Support Engineers card',
	},
	supportEngineersCardSubtitle: {
		id: 'fastshift.relationships-card.subtitle.support-engineers',
		defaultMessage: 'Team of Atlassian experts',
		description: 'Subtitle for the Support Engineers card',
	},
	supportEngineersCardButtonText: {
		id: 'fastshift.relationships-card.button-text.support-engineers',
		defaultMessage: 'Request assistance',
		description: 'Button text for the Support Engineers card',
	},
	supportEngineersCardMessageWhenNoAvaters: {
		id: 'fastshift.relationships-card.message-when-no-avaters.support-engineers',
		defaultMessage: 'Get guidance or support directly from your FastShift team.',
		description: 'Message when no avaters are available',
	},
});
